import { render, staticRenderFns } from "./DriverArchive.vue?vue&type=template&id=19dc66e2&scoped=true&"
import script from "./DriverArchive.vue?vue&type=script&lang=js&"
export * from "./DriverArchive.vue?vue&type=script&lang=js&"
import style0 from "./DriverArchive.vue?vue&type=style&index=0&id=19dc66e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc66e2",
  null
  
)

export default component.exports